<template>
  <transition name="fade">
    <div class="login-row">
      <div class="login justify-content-center">
        <div>
          <div class="row col justify-content-center">
            <a class="valign" href="#">
              <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
            </a>
          </div>

          <div class="row justify-content-center" style="padding: 40px">
            <h2 class="title-principal">Acesso ao Sistema</h2>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-10 col-10">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <v-label label="E-mail"></v-label>
                    <input ref="email" id="email" type="text" class="form-control" v-model="email"
                      @keydown.enter="handleEnter('email')" placeholder="exemplo@exemplo.com.br">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <v-label label="Senha"></v-label>
                    <input ref="senha" id="senha" type="password" class="form-control" v-model="senha"
                      @keydown.enter="handleEnter('senha')" placeholder="">
                  </div>
                </div>
              </div>
              <div class="row col mb-3">
                <a tabindex="1" href="javascript:void(0);" @click="handleRecuperar">
                  Esqueci minha senha
                </a>
              </div>
              <div class="mb-2">
                <alert v-if="errmessages" type="warning" :close="false" title="Erro" :text="errmessages"></alert>
              </div>
              <div class="row">
                <button type="button" id="entrar" class="login-button" style="width: 100%" @click="handleEntrar"
                  :disabled="logando"> {{ botaoEntrar }} </button>
              </div>
              <div class="row col justify-content-center mt-2">
                <a tabindex="1" href="https://www.notabrasil.com.br/criarcontav2/">
                  Criar uma Conta
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login-side-column">
        <div class="login-side-container login-side-container-bg-blue">
          <img class="login-side" src="/nb/atualizacao.png"
            onerror="this.onerror=null; this.src='https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/login.png';"
            alt="Aplicativo Nota Brasil">
          <!-- <div class="login-side" style="background-image: url(https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/login.png);"> -->
          <!-- <div class="login-side" style="background-image: url(https://static.wixstatic.com/media/454959_39f929b7cbca40cbb7ec07c657953697~mv2.jpg);"> -->
          <!-- <img src="https://static.wixstatic.com/media/454959_ecc66f515bfb493db85afea3b3418ecf~mv2.jpg" style="object-fit: cover;"> -->
          <!-- <img src="https://static.wixstatic.com/media/454959_39f929b7cbca40cbb7ec07c657953697~mv2.jpg" style="object-fit: cover;"> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import apiLogin from '../api/api-login.js'

export default {
  componentes: {
  },

  props: {
  },

  data() {
    return {

      registro: {},
      email: null,
      senha: null,
      errmessages: null,  //armazena as mensagens de validacao do servidor para mostrar em tela

      logando: false,

      metadata: {
        registro: {
          email: { label: 'Email Para Login', fieldname: 'email' },
          senha: { label: 'Senha', fieldname: 'senha' },
        }
      },

    }
  },

  mixins: [apiLogin],

  computed: {
    botaoEntrar: function () {
      if (this.logando)
        return 'Acessando...'
      else
        return 'Entrar'
    }
  },

  methods: {
    handleEntrar() {
      this.apiLogin()
    },

    handleRecuperar() {
      this.$router.push('recuperar')
    },

    handleEnter(campo) {
      if (campo === 'email') {
        this.$refs.senha.focus()
      } else {
        this.handleEntrar()
      }
    },


  },

  async mounted() {
    this.email = this.$route.query.email
    const token = this.$route.query.token_autologin;
    if (token) {
      this.logando = true;
      try {
        const url = this.$store.getters.urlApp + 'autologin/auth';
        const res = await this.axios.post(url, { token_uuid: token });
        
        if (res.data && res.data.items && res.data.items.length) {
          const loginData = res.data.items[0];
          
          // Normaliza os dados retornados pelo autologin para compatibilidade com o formato esperado de login
          let parsedApps = [];
          const appsVal = loginData.apps || loginData.APPS;
          if (appsVal) {
            if (Array.isArray(appsVal)) {
              parsedApps = appsVal;
            } else if (typeof appsVal === 'string') {
              try {
                parsedApps = JSON.parse(appsVal);
              } catch (e) {
                parsedApps = [];
              }
            }
          }
          
          const normalizedLogin = {
            ...loginData,
            uuid: loginData.uuid || loginData.UUID || loginData.empresa || loginData.EMPRESA,
            email: loginData.email || loginData.EMAIL,
            usuarionome: loginData.usuarionome || loginData.nome || loginData.NOME,
            empresanome: loginData.empresanome || loginData.empresa_nome || loginData.EMPRESA_NOME,
            empresacod: loginData.empresacod || loginData.empresacod_destino || loginData.EMPRESA_COD,
            tpempresa: loginData.tpempresa || loginData.TPEMPRESA,
            istrial: loginData.istrial === 'S' || loginData.istrial === true || loginData.ISTRIAL === 'S' || loginData.ISTRIAL === true,
            isendtrial: loginData.isendtrial === 'S' || loginData.isendtrial === true || loginData.ISENDTRIAL === 'S' || loginData.ISENDTRIAL === true,
            isblocked: loginData.isblocked === 'S' || loginData.isblocked === true || loginData.ISBLOCKED === 'S' || loginData.ISBLOCKED === true,
            apps: parsedApps
          };
          
          this.apiLoginToken(normalizedLogin);
        } else {
          alert('Token de acesso expirado ou inválido.');
          this.logando = false;
        }
      } catch (err) {
        alert('Erro na autenticação silenciosa.');
        this.logando = false;
      }
      return;
    }

    if (this.email && this.email !== '') {
      if (this.$route.query.newaccount == 'true') {
        this.apiLoginNewAccount()
      } else {
        this.$nextTick(function () {
          this.$refs.senha.focus()
        })
      }
    }


  },

  created() {
    this.email = ''
    this.$nextTick(function () {
      this.$refs.email.focus()
    })
    this.$scrollTo(0)
  }

}

</script>

<style>
.shared-header {
  padding: 15px 0;
  margin-top: 15px;
}

.shared-header .valign {
  line-height: 30px;
  vertical-align: middle;
}

.login-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 0;
  height: 100vh;
}

.login {
  display: flex;
  background-color: #fff;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0;
  position: relative;
}

.login-side-column {
  background-color: #fff;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.666667%;
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
  /* min-height: 100vh; */
  position: relative;
  box-sizing: border-box;
  padding: 0;
}

.login-side-container {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: end;
}

.login-side-container-bg-blue {
  background-color: #0f3e76;
  ;
}

@media screen and (max-width: 1199px) {
  .login {
    display: flex;
    background-color: #fff;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    min-height: 100vh;
  }

  .login-side-column {
    display: none;
  }

}

.login-side {
  width: 66.666667%;
  position: absolute;
}



.box-login {
  margin: 10px 0 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #E0E0E0; */
  border-radius: 15px;
  padding: 100px 30px 100px;
  letter-spacing: -0.15px;
  line-height: 24px;
  transition: all .2s;
  box-shadow: 0 15px 45px 0 rgba(82, 95, 127, .15);
}

.login-button {
  border: 2px solid #267da5 !important;
  /* border-radius: 3px!important; */
  border-radius: 0.70rem;
  /* margin-top: 50px; */
  cursor: pointer;
  height: 45px !important;
  background-color: #267da5 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.title-principal {
  color: #222;
  font-size: 36px;
  /* font-weight: 800; */
  letter-spacing: -1.13px;
  line-height: 44px;
  margin: 25px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/forms/app-login-form.vue